export const LOGO_URL = "https://d1yei2z3i6k35z.cloudfront.net/14641248/68ea6f71dafb3_logoHorsePower.png";

export const HERO_VIDEO_URL = "https://customer-assets.emergentagent.com/job_horsepower-bootcamp/artifacts/hkh9eq72_692ed2244f7cb_FORMATIONIO.mp4";

export const CENTERS = [
  {
    city: "Béziers",
    label: "Centre historique",
    instagram: "horsepower_beziers",
    url: "https://www.instagram.com/horsepower_beziers/",
    primary: true,
    description: "Le berceau d'Horsepower. Centre principal de formation présentielle, équipé d'un banc de puissance et de l'outillage pro complet.",
  },
  {
    city: "Montpellier",
    label: "Antenne sud",
    instagram: "horsepower_montpellier",
    url: "https://www.instagram.com/horsepower_montpellier/",
    primary: false,
    description: "Reprogrammation, conversions E85 et préparations Stage 1/Stage 2 pour toute la région Hérault.",
  },
  {
    city: "Perpignan",
    label: "Pyrénées-Orientales",
    instagram: "horsepower_perpignan",
    url: "https://www.instagram.com/horsepower_perpignan/",
    primary: false,
    description: "L'expertise Horsepower déployée à la frontière espagnole. Spécialistes diesel et essence.",
  },
  {
    city: "Marseille",
    label: "Antenne Provence",
    instagram: "horsepower_marseille",
    url: "https://www.instagram.com/horsepower_marseille/",
    primary: false,
    description: "Le centre marseillais : reprogrammation, diagnostic avancé et préparation moteur sur la côte méditerranéenne.",
  },
];

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_horsepower-bootcamp/artifacts/pw59ju5z_03A6A4AF-65FD-461C-9435-D31DDE88A8D3%20%282%29.PNG";
export const ENGINE_IMAGE = "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?q=80&w=2000&auto=format&fit=crop";
export const DYNO_IMAGE = "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2000&auto=format&fit=crop";

export const MODULES = [
  { n: "01", title: "Découvrir le métier", icon: "Compass", desc: "Comprendre le marché de la reprogrammation moteur, les opportunités, les marges, le positionnement et les pièges à éviter avant de se lancer." },
  { n: "02", title: "Le matériel professionnel", icon: "Wrench", desc: "Sélection des outils OBD, interfaces de lecture/écriture, valise diag, banc de puissance, équipements indispensables et budget réel à prévoir." },
  { n: "03", title: "Lecture et écriture ECU", icon: "Cpu", desc: "Méthodologie pas à pas pour lire et flasher une ECU en OBD, Bench et Boot. Sécurité, sauvegardes et gestion des erreurs." },
  { n: "04", title: "Comprendre les cartographies", icon: "LineChart", desc: "Décrypter les maps : injection, allumage, suralimentation, AFR, couple, vitesse maxi, limiteurs. Lecture pro des cartes constructeurs." },
  { n: "05", title: "Prestations commerciales", icon: "Gauge", desc: "Maîtriser les conversions E85, Stage 1, Stage 2. Préparer des fichiers performants et fiables que vous vendrez en toute confiance." },
  { n: "06", title: "Exploiter un File Service", icon: "Server", desc: "Travailler avec un fournisseur de fichiers (File Service Horsepower) : briefs, allers-retours, qualité, délais et facturation." },
  { n: "07", title: "Diagnostic et résolution", icon: "Stethoscope", desc: "Lire les codes défauts, intervenir post-reprog, gérer un véhicule qui ne démarre plus, recovery ECU bricked et SAV client." },
  { n: "08", title: "Publicité Meta Ads", icon: "Megaphone", desc: "Créer et scaler des campagnes Facebook & Instagram qui convertissent : ciblages, créas, pixels, suivi et budget pour reprogrammeurs." },
  { n: "09", title: "Google Business Profile", icon: "MapPin", desc: "Référencement local Google Maps, avis clients, photos optimisées, mots-clés. Devenir le n°1 de la reprog sur votre zone." },
  { n: "10", title: "Vente et relation client", icon: "Handshake", desc: "Scripts d'appel, devis qui closent, gestion des objections, fidélisation, upsell E85→Stage 1. Convertir 80% de vos demandes." },
  { n: "11", title: "Développer son entreprise", icon: "Building2", desc: "Statut juridique, fiscalité, comptabilité, recrutement, ouverture d'un local, scaling. Passer de 3K€/mois à 20K€/mois proprement." },
  { n: "12", title: "Cas pratiques réels", icon: "Car", desc: "Études de cas filmées sur véhicules clients : Golf 7 GTI, 308 GTi, Clio RS, M2 Compétition. Du devis à la livraison." },
];

export const SESSIONS = [
  { city: "Béziers", slot: "Session 1", places: 4 },
  { city: "Béziers", slot: "Session 2", places: 4 },
  { city: "Béziers", slot: "Session 3", places: 4 },
  { city: "Béziers", slot: "Session 4", places: 4 },
];

export const TESTIMONIALS = [
  {
    name: "Marc Delarue",
    role: "Ex-mécanicien, Toulouse",
    photo: "https://customer-assets.emergentagent.com/job_horsepower-bootcamp/artifacts/oy9109wp_IMG_8494.jpg",
    quote: "J'ai lancé mon activité 3 semaines après la formation. Premier mois : 4 200€ HT en reprogrammant des Golf, 308 et Mégane RS. Le module Meta Ads change la donne.",
    stat: "+4 200€ premier mois",
  },
  {
    name: "Kevin Marchetti",
    role: "Préparateur auto, Lyon",
    photo: "https://customer-assets.emergentagent.com/job_horsepower-bootcamp/artifacts/5rufmj8a_IMG_8496.jpg",
    quote: "Je faisais déjà de la prépa, je passais par un fournisseur extérieur pour les fichiers. Maintenant je fais tout en interne, je marge x3 sur chaque prestation.",
    stat: "Marge x3 par véhicule",
  },
  {
    name: "Ludovic Garcia",
    role: "Garagiste, Bordeaux",
    photo: "https://customer-assets.emergentagent.com/job_horsepower-bootcamp/artifacts/ty1yvdoi_IMG_8495.jpg",
    quote: "Formation présentielle à Béziers : on a vraiment mis les mains dedans, sur de vrais véhicules clients. Aucune autre formation ne fait ça en France.",
    stat: "Cas réels vécus",
  },
  {
    name: "Yanis Berkane",
    role: "Indépendant, Marseille",
    photo: "https://customer-assets.emergentagent.com/job_horsepower-bootcamp/artifacts/3wf0yc4f_IMG_8498.jpg",
    quote: "Le File Service Horsepower est une vraie sécurité quand on débute. On envoie le fichier, on a un retour pro en 2h. Mes clients sont bluffés.",
    stat: "Retour fichier en 2h",
  },
  {
    name: "Thomas Vidal",
    role: "Entrepreneur, Nantes",
    photo: "https://customer-assets.emergentagent.com/job_horsepower-bootcamp/artifacts/oqxvw1ql_IMG_8500.jpg",
    quote: "Je viens de l'IT, zéro background mécanique. La formation est pensée pour ça : on monte en compétence vite, sans bullshit. CA prévisionnel atteint en 4 mois.",
    stat: "Reconversion réussie",
  },
];

export const FAQ_ITEMS = [
  {
    q: "Faut-il être mécanicien pour suivre la formation ?",
    a: "Non. La formation est conçue pour permettre à un débutant motivé d'arriver à un niveau professionnel. Les notions mécaniques essentielles sont reprises depuis la base. Le profil idéal est un passionné automobile qui veut en faire son métier — pas nécessairement un mécano diplômé.",
  },
  {
    q: "Quel matériel dois-je acheter pour me lancer ?",
    a: "Le module 2 détaille exactement la liste : interface de lecture/écriture (env. 2 000-3 000€ selon marque), valise diag, ordinateur portable robuste. Budget de démarrage réaliste : 2 300 à 4 800€ TTC pour être 100% opérationnel.",
  },
  {
    q: "Combien peut-on gagner avec la reprogrammation ?",
    a: "Une prestation E85 se vend entre 350 et 450€, un Stage 1 entre 400 et 600€, un Stage 2 entre 700 et 900€. Avec 2-3 prestations par semaine en démarrage, vous êtes déjà entre 3 000 et 6 000€ de CA mensuel. Nos meilleurs élèves dépassent 35 000€/mois.",
  },
  {
    q: "Combien de temps dure la formation ?",
    a: "La formation en ligne est accessible à vie, à votre rythme : compter 10h de contenu vidéo + cas pratiques. La formation présentielle Premium dure 3 jours intensifs dans un centre Horsepower, avec mise en pratique immédiate.",
  },
  {
    q: "Y a-t-il un accompagnement après la formation ?",
    a: "Oui. Vous gardez l'accès à vie au contenu, aux mises à jour, au groupe privé d'entraide et au File Service Horsepower. Sessions live mensuelles incluses. La formule Premium ajoute un support privilégié 6j/7 sur WhatsApp.",
  },
  {
    q: "Peut-on ouvrir son activité après la formation ?",
    a: "Absolument — c'est même l'objectif. Le module 11 couvre statut juridique (auto-entrepreneur, EURL, SASU), fiscalité, comptabilité, premières démarches. Vous repartez avec un plan d'action concret pour démarrer dans les 30 jours.",
  },
];
